import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderSlot as _renderSlot, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "header-container" }
const _hoisted_4 = { class: "title-container" }
const _hoisted_5 = { class: "pin-container" }
const _hoisted_6 = ["title"]
const _hoisted_7 = ["alt", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_ModalCard = _resolveComponent("ModalCard")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_sidebar_menu = _resolveComponent("sidebar-menu")!
  const _component_Actualites = _resolveComponent("Actualites")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_ReglesPanneau = _resolveComponent("ReglesPanneau")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass({ backgroundGris: _ctx.actualitesOpen || _ctx.onboardingOpen }),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideActusalites && _ctx.hideActusalites(...args)))
    }, null, 2),
    (_ctx.modaleBimOuverte)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modaleBimOuverte = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ModalCard, {
              activeValidate: false,
              withoutBotNav: true,
              headerTitle: "B.I.M.",
              onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modaleBimOuverte = false))
            }, {
              "header-append": _withCtx(() => [
                _createVNode(_component_ReglePastille, {
                  cle: "bim.definition",
                  placement: "bottom"
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(_ctx.modaleBimMessage), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_MainHeader, {
        connected: !_ctx.isNoteReclamation
      }, null, 8, ["connected"]),
      (!_ctx.isNoteReclamation && _ctx.menuLoaded)
        ? (_openBlock(), _createElementBlock("nav", {
            key: 0,
            "aria-label": _ctx.$t('aria.menu.lateral')
          }, [
            _createVNode(_component_sidebar_menu, {
              collapsed: _ctx.isCollapsed,
              "hide-toggle": true,
              menu: _ctx.menu,
              "show-one-child": true,
              width: '500px',
              class: "menu",
              onMouseenter: _ctx.expandMenu,
              onMouseleave: _ctx.collapseMenu,
              onItemClick: _ctx.onItemClick
            }, {
              header: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('menu.portail.title')), 1),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("button", {
                      class: _normalizeClass([{ 'is-pinned': _ctx.isPinned }, "pin-button"]),
                      title: _ctx.isPinned ? _ctx.$t('menu.portail.unpin') : _ctx.$t('menu.portail.pin'),
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.pinMenu && _ctx.pinMenu(...args)))
                    }, [
                      _createElementVNode("img", {
                        alt: _ctx.$t('menu.portail.alt.pin'),
                        src: _ctx.getPinIcon
                      }, null, 8, _hoisted_7)
                    ], 10, _hoisted_6)
                  ])
                ], 512), [
                  [_vShow, !_ctx.isCollapsed]
                ])
              ]),
              _: 1
            }, 8, ["collapsed", "menu", "onMouseenter", "onMouseleave", "onItemClick"])
          ], 8, _hoisted_2))
        : _createCommentVNode("", true),
      (!_ctx.actualitesLoading && _ctx.isDashboard)
        ? (_openBlock(), _createBlock(_component_Actualites, {
            key: 1,
            actualites: _ctx.actualites,
            class: "actualites"
          }, null, 8, ["actualites"]))
        : _createCommentVNode("", true),
      _createElementVNode("main", {
        id: "main-content",
        class: _normalizeClass([{ 'content-dashboard': _ctx.isDashboard || _ctx.isDashboardFournisseur }, "content"]),
        role: "main"
      }, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ], 2),
      (!_ctx.isNoteReclamation && !_ctx.isEditionDashboard && (_ctx.isDashboard || _ctx.isDashboardFournisseur))
        ? (_openBlock(), _createBlock(_component_Footer, {
            key: 2,
            connected: !_ctx.isNoteReclamation
          }, null, 8, ["connected"]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.isNoteReclamation && _ctx.autoriseReglesGestion)
      ? (_openBlock(), _createBlock(_component_ReglesPanneau, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}